import React from 'react';
import { Route } from 'react-router-dom';
import { PublicRoute } from '@/routes/guards';
import { lazyWithRetry } from '@/routes/utils';

const Login = lazyWithRetry(() => import('@/pages/auth/Login'));
const Register = lazyWithRetry(() => import('@/pages/auth/Register'));
const ForgotPassword = lazyWithRetry(() => import('@/pages/auth/ForgotPassword'));
const SocialAuthCallback = lazyWithRetry(() => import('@/pages/auth/SocialAuthCallback'));
const EmailChangeConfirm = lazyWithRetry(() => import('@/pages/auth/EmailChangeConfirm'));
const ForcePasswordChange = lazyWithRetry(() => import('@/pages/auth/ForcePasswordChange'));

export const authRoutes = (
  <>
    <Route
      path="/login"
      element={
        <PublicRoute>
          <Login />
        </PublicRoute>
      }
    />
    <Route
      path="/register"
      element={
        <PublicRoute>
          <Register />
        </PublicRoute>
      }
    />
    <Route
      path="/forgot-password"
      element={
        <PublicRoute>
          <ForgotPassword />
        </PublicRoute>
      }
    />
    <Route path="/auth/callback" element={<SocialAuthCallback />} />
    <Route path="/email-change/confirm" element={<EmailChangeConfirm />} />
    <Route path="/change-password" element={<ForcePasswordChange />} />
  </>
);
